import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import logo from "../../images/spectre_logo_2022.png";

const LogoContainer = styled.img`
  width: 445px;
  height: unset;
  aspect-ratio: 588 / 210;
  margin: 0;
  padding: 0;

  @media (max-width: 450px) and (orientation: Portrait) {
    width: 333.75px;
  }

  @media (max-width: 320px) and (orientation: Portrait) {
    width: 222.5px;
  }
`;

const loadingContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-around",
  width: "100vw",
  height: "100vh",
  position: "absolute",
};
const textStyle = {
  textAlign: "center",
  font: "normal normal normal 14px/21px Poppins",
  letterSpacing: "0.09px",
  color: "#00187E",
  opacity: "0.65",
};

export const LoadingPage = ({ loadingMessage = "general.Loading" }) => {
  const { t } = useTranslation();

  return (
    <div style={loadingContainer}>
      <LogoContainer src={logo} alt="Spectre logo" />
      <span style={textStyle}>{t(loadingMessage)}</span>
    </div>
  );
};
